import { useEffect, useRef, useState } from 'react'
import { ChevronLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { navigate } from 'wouter/use-browser-location'

declare global {
  interface Window {
    ktt10?: {
      setup: (config: Record<string, unknown>) => void;
    };
    ktt10Btn?: HTMLElement;
  }
}

export default function ChatPage() {
  const [isLoading, setIsLoading] = useState(true)
  const scriptLoadedRef = useRef(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loadChatWidget = () => {
      // Check if script already exists
      const existingScript = document.querySelector('script[src*="chatgptbuilder.io/webchat/plugin.js"]')

      const initWidget = () => {
        if (window.ktt10 && containerRef.current) {
          window.ktt10.setup({
            id: "J8ND5vinix",
            accountId: "1998884",
            color: "#36D6B5",
            type: "container",
            element: "#chat-container",
            hideHeader: true
          })
          setIsLoading(false)
        }
      }

      if (existingScript) {
        scriptLoadedRef.current = true
        // Small delay to ensure ktt10 is available
        setTimeout(initWidget, 100)
        return
      }

      const script = document.createElement('script')
      script.src = 'https://app.chatgptbuilder.io/webchat/plugin.js?v=6'
      script.async = true
      script.onload = () => {
        scriptLoadedRef.current = true
        initWidget()
      }
      document.body.appendChild(script)
    }

    loadChatWidget()
  }, [])

  const handleBack = () => {
    navigate('/')
  }

  return (
    <div className="h-screen bg-[#18181B] flex flex-col overflow-hidden max-w-5xl mx-auto px-5 pb-8">
      {/* Header */}
      <div className="flex items-center gap-3 p-4 bg-[#18181B] shrink-0 z-[100]">
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 rounded-full bg-[#2A2A2A]"
          onClick={handleBack}
        >
          <ChevronLeft className="h-5 w-5 text-white" />
        </Button>
        <h1 className="text-[20px] leading-[18px] font-bold font-montserrat tracking-wide text-white">
          Chat Support
        </h1>
      </div>

      {/* Chat container */}
      <div
        id="chat-container"
        ref={containerRef}
        className="flex-1 w-full"
      />

      {/* Loading state */}
      {isLoading && (
        <div className="absolute inset-0 top-[56px] flex items-center justify-center bg-[#18181B]">
          <div className="text-white/50 text-sm">Loading chat...</div>
        </div>
      )}
    </div>
  )
}
